import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ListCategoryUserSitePublisher from "./ListCategoryUserSitePublisher";
import helperNumber from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";

export default function AllCategoryUserSitePublisher({ userID }) {
  const [allCategoryUserSitePublisher, setAllCategoryUserSitePublisher] =
    useState([]);

  useEffect(() => {
    getAllCategoryUserSitePublisher();
  }, [userID]);

  const getAllCategoryUserSitePublisher = async () => {
    let categoriesUserSitePublisher = ListCategoryUserSitePublisher.filter(
      (categoryUserSitePublisher) => categoryUserSitePublisher.user_id == userID
    );

    setAllCategoryUserSitePublisher(categoriesUserSitePublisher);
  };

  const generateAllCategoryUserSitePublisherTag = () => {
    return (
      <>
        <div className="py-2">
          <Link
            to={`/publishers/coworker/add-group/banner/${userID}`}
            className="btn btn-success"
          >
            <span class="pl-2">
              <i class="fa fa-plus"></i>
            </span>
            <span>گروه جدید بنری</span>
          </Link>
        </div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space  mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>نام</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allCategoryUserSitePublisher.map(
                (categoryUserSitePublisherTag, index) => {
                  return (
                    <tr key={categoryUserSitePublisherTag.id}>
                      <td>{helperNumber.toPersianNum(index + 1)}</td>
                      <td>
                        {helperNumber.toPersianNum(
                          categoryUserSitePublisherTag.id
                        )}
                      </td>
                      <td>{categoryUserSitePublisherTag.name}</td>

                      <td className="number-finance">
                        <span>
                          {helperNumber.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.start_date
                            )
                          )}
                        </span>
                        <span className="pl-2">۰۰:۰۰</span>
                      </td>
                      <td className="number-finance">
                        <span>
                          {helperNumber.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.end_date
                            )
                          )}
                        </span>
                        <span className="pl-2">۲۳:۵۹</span>
                      </td>
                      <td className="number-finance">
                        {helperNumber.toPersianNum(
                          categoryUserSitePublisherTag.created_at.split(
                            " "
                          )[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              categoryUserSitePublisherTag.created_at.split(
                                " "
                              )[0]
                            )
                        )}
                      </td>
                      <td>
                        <div>
                          <span className="pl-2">
                            <Link
                              to={`/publishers/edit-group/${categoryUserSitePublisherTag.id}`}
                              className="btn btn-success  "
                            >
                              <i className="fa fa-edit"></i>
                            </Link>
                          </span>
                        </div>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return generateAllCategoryUserSitePublisherTag();
}
